exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-24R[data-v-1a3d6c88] {\n\twidth: 24rem;\n}\n.w-100[data-v-1a3d6c88] {\n\twidth: 100%;\n}\n", ""]);

// exports
